import { Component, Input } from '@angular/core';
import { LOADER_TYPES } from '../../constants/app-enums';

@Component({
  selector: 'app-custom-image',
  templateUrl: './custom-image.component.html',
  styleUrls: ['./custom-image.component.scss']
})
export class CustomImageComponent {
  @Input({ required: true }) src!: string | undefined;
  @Input({ required: true }) alt!: string;
  @Input() loaderType: LOADER_TYPES = LOADER_TYPES.SPINNER;
  @Input() loaderGif!: string;
  LOADER_TYPES = LOADER_TYPES;
  loadingImage = true;

  onImageLoad() {
    this.loadingImage = false;
  }
}
